import { gql as t } from "@apollo/client";
import { PublicAccountFragment as i, PublicInvitationFragment as n } from "../fragment/account.js";
const e = t`
  query CheckAdeptusInviter($code: String!) {
    getAdeptusCampaignInviter(input: { invitationCode: $code }) {
      account {
        ...PublicAccount
      }
      accountInvitation {
        ...PublicInvitation
      }
    }
  }

  ${i}
  ${n}
`;
export {
  e as default
};
//# sourceMappingURL=checkAdeptusInviter.js.map
